module.exports = __webpack_public_path__ + "img/bird.2ad8f672.png";